<template>
  <v-dialog
    overlay-color="black"
    overlay-opacity="0.7"
    persistent
    max-width="760"
    width="94vw"
    v-model="show"
  >
    <v-card :dark="darkMode" class="tos-dialog-card">
      <v-card-title class="headline" :class="titleTextClass">
        Terms of Service
      </v-card-title>
      <v-card-text :class="bodyTextClass">
        <p v-if="isUpdate">
          Our Terms of Service have been updated
          <template v-if="currentVersion"> (version {{ currentVersion }})</template>.
          Please review and accept to continue using the application.
        </p>
        <p v-else>
          Please read and accept our Terms of Service to continue using the
          application.
        </p>
        <p>
          For details about data processing, please also review our
          <a
            class="tos-dialog-link"
            href="https://dicom.vision/web-privacy-policy-cookie"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>.
        </p>
        <div class="tos-dialog-content">
          <div class="tos-dialog-scrollable">
            {{ content }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('accept')">
          Accept
        </v-btn>
        <v-btn text @click="$emit('decline')">
          Decline
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  computed: {
    ...mapGetters(["darkMode"]),
    titleTextClass() {
      return this.darkMode ? "white--text" : "grey--text text--darken-3";
    },
    bodyTextClass() {
      return this.darkMode ? "grey--text text--lighten-1" : "grey--text text--darken-2";
    }
  },
  props: {
    show: { type: Boolean, required: true },
    content: { type: String, required: true },
    isUpdate: { type: Boolean, default: false },
    currentVersion: { type: String, default: "" }
  }
};
</script>

<style lang="scss">
.tos-dialog-card {
  border-radius: 12px;
  overflow: hidden;
}

.tos-dialog-content,
.tos-content {
  margin: 1rem 0 0.5rem;
}

.tos-dialog-scrollable,
.tos-scrollable {
  --tos-scroll-track: rgba(0, 0, 0, 0.06);
  --tos-scroll-thumb: rgba(60, 60, 67, 0.45);
  --tos-scroll-thumb-hover: rgba(60, 60, 67, 0.65);
  max-height: min(56vh, 420px);
  overflow-y: auto;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: var(--tos-scroll-thumb) var(--tos-scroll-track);
  padding: 1rem 1rem 1.1rem;
  border-radius: 4px;
  white-space: pre-wrap;
  line-height: 1.5;
  font-size: 0.92rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
}

.tos-dialog-scrollable::-webkit-scrollbar,
.tos-scrollable::-webkit-scrollbar {
  width: 10px;
}

.tos-dialog-scrollable::-webkit-scrollbar-track,
.tos-scrollable::-webkit-scrollbar-track {
  background: var(--tos-scroll-track);
  border-radius: 999px;
}

.tos-dialog-scrollable::-webkit-scrollbar-thumb,
.tos-scrollable::-webkit-scrollbar-thumb {
  background: var(--tos-scroll-thumb);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.tos-dialog-scrollable::-webkit-scrollbar-thumb:hover,
.tos-scrollable::-webkit-scrollbar-thumb:hover {
  background: var(--tos-scroll-thumb-hover);
  background-clip: padding-box;
}

.tos-dialog-card.theme--dark .tos-dialog-scrollable,
.tos-dialog-card.theme--dark .tos-scrollable,
.theme--dark .tos-scrollable {
  --tos-scroll-track: rgba(255, 255, 255, 0.08);
  --tos-scroll-thumb: rgba(255, 255, 255, 0.35);
  --tos-scroll-thumb-hover: rgba(255, 255, 255, 0.52);
  border-color: rgba(255, 255, 255, 0.2);
  background: #1f1f1f;
  color: rgba(255, 255, 255, 0.9);
}

.tos-dialog-link {
  text-decoration: underline;
}

.theme--dark .tos-dialog-link {
  color: #90caf9;
}
</style>
